import React, { lazy } from 'react';

import createRoute from '@/core/Router/createRoute';
import Logout from '@/core/Logout';

const Home           = lazy(() => import('@/core/Home')),
	  UserDetails    = lazy(() => import('@/core/UserDetails')),
	  UserManagement = lazy(() => import('@/core/UserManagement')),
	  UserGroups     = lazy(() => import('@/core/UserGroups')),
	  Permissions    = lazy(() => import('@/core/Permissions')),
	  Services       = lazy(() => import('@/core/Services')),
	  Tests          = lazy(() => import('@/core/_Tests'));


export let routes = [

	createRoute({
		path:    '/logout',
		exact:   true,
		render:  <Logout />,
		title:   'Log Out',
		private: true,
	}),

	createRoute({
		path:    '/user-details',
		exact:   true,
		render:  <UserDetails />,
		title:   'User Details',
		private: true,
	}),

	createRoute({
		path:        '/_tests',
		exact:       true,
		render:      <Tests />,
		title:       'Tests',
		private:     true,
		permissions: [ 'superadmin' ],
	}),



	createRoute({
		path:    '/admin/user-management',
		exact:   true,
		render:  <UserManagement />,
		title:   'User Management',
		private: true,
	}),

	createRoute({
		path:    '/admin/user-groups',
		exact:   true,
		render:  <UserGroups />,
		title:   'User Groups',
		private: true,
	}),

	createRoute({
		path:    '/admin/permissions',
		exact:   true,
		render:  <Permissions />,
		title:   'Permissions',
		private: true,
	}),

	createRoute({
		path:    '/admin/services',
		exact:   true,
		render:  <Services />,
		title:   'Manage Services',
		private: true,
	}),


	createRoute({
		path:    '/',
		exact:   true,
		render:  <Home />,
		title:   'Internal Portal Home',
		private: true,
	}),

];


/*
 * Route-registration reactivity. nondev plugins load asynchronously (see
 * src/plugins.js), so a plugin can register its routes AFTER React's first
 * render - on a hard refresh at a plugin URL the Switch would match nothing,
 * show NotFound, and stick, because nothing re-rendered the Router. The
 * Router subscribes to this version counter (useSyncExternalStore) and
 * re-renders whenever routes register, swapping NotFound for the real page.
 */
let routesVersion = 0;
const routeListeners = new Set();

export function subscribeRoutes(listener) {
	routeListeners.add(listener);
	return () => routeListeners.delete(listener);
}

export function getRoutesVersion() {
	return routesVersion;
}

function registerRoutes(newRoutes, location = 'start') {
	if(location === 'start') {
		routes = [ ...newRoutes.map(route => createRoute(route)), ...routes ];
	} else {
		routes = [ ...routes, ...newRoutes.map(route => createRoute(route)) ];
	}

	routesVersion++;
	routeListeners.forEach(listener => {
		try {
			listener();
		} catch(err) {
			console.error('[routes] listener threw on route registration:', err);
		}
	});
}

export { registerRoutes };
